import styled from 'styled-components';

export const TituloComBadge = styled.span`
  margin-right: 15px;
`;
